import React from "react";
import MenuSuperior from "./appLayout/MenuSuperior";

function AppLayout(props) {
  return <MenuSuperior>{props.children}</MenuSuperior>;
}

export default AppLayout;



// WEBPACK FOOTER //
// ./src/pages/AppLayout.jsx